import OnlyShowOnDesktop from 'src/components/util/OnlyShowOnDesktop';
import Title from 'src/components/util/Title';
const DesktopTitle = ({ title, sx }) => {
  return (
    <>
      <OnlyShowOnDesktop>
        <Title title={title} sx={sx} />
      </OnlyShowOnDesktop>
    </>
  );
};

export default DesktopTitle;
